import { createReducer, on } from '@ngrx/store';
import { CurrentChargerState } from './chargerOverview.models';
import * as currentChargerActions from './chargerOverview.actions';

export const initialCurrentChargerState: CurrentChargerState = {
  chargerId: null,
  chargerOverview: null,
  loading: false,
  error: null,
  locationUpdated: false,
  savingNoteInProgress: false,
  noteSaved: false,
};

export const currentChargerReducer = createReducer(
  initialCurrentChargerState,
  on(currentChargerActions.loadChargerOverview, (state, { chargerId }) => ({
    ...state,
    chargerId: chargerId,
  })),
  on(currentChargerActions.loadChargerOverviewFailure, (state, { error }) => ({
    ...state,
    error: error?.errorMessage ?? 'ERROR',
    loading: false,
  })),
  on(
    currentChargerActions.loadChargerOverviewSuccess,
    (state, { chargerOverview }) => ({
      ...state,
      chargerOverview: chargerOverview,
      loading: false,
      error: null,
    })
  ),
  on(currentChargerActions.updateChargerLocation, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    currentChargerActions.updateChargerLocationSuccess,
    (state, { location }) => ({
      ...state,
      chargerOverview: {
        ...state.chargerOverview,
        chargerId: state.chargerOverview!.chargerId,
        serialNumber: state.chargerOverview!.serialNumber,
        location: location,
      },
      loading: false,
      error: null,
      locationUpdated: true,
    })
  ),
  on(
    currentChargerActions.updateChargerLocationFailure,
    (state, { error }) => ({
      ...state,
      error: error?.errorMessage ?? 'ERROR',
      loading: false,
      locationUpdated: false,
    })
  ),
  on(currentChargerActions.updateChargerLocationResetState, (state) => ({
    ...state,
    loading: false,
    locationUpdated: false,
  })),
  on(currentChargerActions.saveNewNote, (state) => ({
    ...state,
    savingNoteInProgress: true,
    noteSaved: false,
  })),
  on(currentChargerActions.saveNewNoteSuccess, (state, noteResult) => ({
    ...state,
    chargerOverview: {
      ...state.chargerOverview,
      chargerId: state.chargerOverview!.chargerId,
      serialNumber: state.chargerOverview!.serialNumber,
      notes: [...(state.chargerOverview?.notes ?? []), noteResult.note], // ← correct appending
    },
    savingNoteInProgress: false,
    noteSaved: true,
  })),
  on(currentChargerActions.saveNewNoteFailure, (state, { error }) => ({
    ...state,
    error: error?.errorMessage ?? 'ERROR',
    savingNoteInProgress: false,
    noteSaved: false,
  })),
  on(currentChargerActions.saveNewNoteReset, (state) => ({
    ...state,
    savingNoteInProgress: false,
    noteSaved: false,
  })),
  on(
    currentChargerActions.chargerConnectionChanged,
    (state, connectionStatus) => ({
      ...state,
      chargerOverview: {
        ...state.chargerOverview,
        chargerId: state.chargerOverview!.chargerId,
        serialNumber: state.chargerOverview!.serialNumber,
        connectionStatus: connectionStatus.chargerConnectionStatus,
      },
    })
  ),
  on(
    currentChargerActions.operatorDetailsUpdatedSuccess,
    (state, { updateResult: details }) => ({
      ...state,
      chargerOverview: {
        ...state.chargerOverview,
        chargerId: state.chargerOverview!.chargerId,
        serialNumber: state.chargerOverview!.serialNumber,
        installationDate: details.chargerInstallationDate,
        reference: details.chargerReference,
        tariffName: details.tariffName,
        tariffId: details.tariffId,
        operator: {
          ...state.chargerOverview?.operator,
          countryCode: state.chargerOverview!.operator!.countryCode,
          name: state.chargerOverview!.operator!.name,
          partyId: state.chargerOverview!.operator!.partyId,
        },
      },
    })
  ),
  on(currentChargerActions.updateChardiStatusOnConnector, (state, { connectorId, isChardi }) => ({
    ...state,
    chargerOverview: {
      ...state.chargerOverview!,
      connectorList: [...state.chargerOverview?.connectorList?.map(x => x.id == connectorId ? { ...x, isChardi: isChardi } : x) ?? []]
    }
  }))
);
